import TreeNode from '../tree-node';

const DEFAULT_OPTIONS = {
  childProperty: 'children',
  formatItem: (item) => item,
};

export default {
  createTree (Entity, entityData, options = {}) {
    return new TreeNode(entityData, {
      ...DEFAULT_OPTIONS,
      ...options,
      DataEntity: Entity,
    });
  },
  createTreeList (Entity, data, options = {}) {
    return data.map(item => this.createTree(Entity, item));
  },
};
